var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var TechnicalComponent = /** @class */ (function (_super) {
    __extends(TechnicalComponent, _super);
    function TechnicalComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.items = [
            5,
            2,
            5,
            4,
            3,
            3,
            4,
            4,
            6
        ];
        return _this;
    }
    TechnicalComponent.prototype.newArray = function (count) {
        return Array.from(Array(count).keys());
    };
    TechnicalComponent.prototype.ngOnInit = function () {
        this.setTitle('Detaliile tehnice ale proiectului Romanescu Park Residence');
        this.setMetaDescription("\n      Proiectul Romanescu Park Residence include: tructur\u0103 de rezisten\u021B\u0103 din cadre \u0219i plan\u0219ee de\n      beton armat, agent termic \u00EEn sistem individual cu centrale termice de apartament, u\u0219i exterioare\n      apartament metalice cu sisteme complexe de \u00EEnchidere \u0219i vizor, instala\u021Bie de interfon \u0219i control\n      acces etc.\n    ");
    };
    return TechnicalComponent;
}(SeoAwareBaseComponent));
export { TechnicalComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/technical.component.ts.pre-build-optimizer.js